import { alpha, Box, Grid, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import { DefaultButton, MainInput, MainSelect, SuccessButton } from "..";
import { useEffect, useState } from "react";


export default function PaymentBillingInfoModal(props) {
    const { open, onClose, onFinish, address } = props;

    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 750,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    }

    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [line1, setLine1] = useState("");
    const [line2, setLine2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [line1Error, setLine1Error] = useState(false);
    const [line2Error, setLine2Error] = useState(false);
    const [cityError, setCityError] = useState(false);
    const [country, setCountry] = useState("");
    const [countryError, setCountryError] = useState(false);
    const [stateError, setStateError] = useState(false);
    const [postalCodeError, setPostalCodeError] = useState(false);

    useEffect(() => {
        if (address) {
            setEmail(address.email ?? "");
            setName(address.name ?? "");
            setLine1(address?.address?.line1 ?? "");
            setLine2(address?.address?.line2 ?? "");
            setCity(address?.address?.city ?? "");
            setState(address?.address?.state ?? "");
            setCountry(address?.address?.country ?? "");
            setPostalCode(address?.address?.postal_code ?? "");
        }
    }, [open, address]);

    const onSubmit = (e) => {
        e.preventDefault();
        var isValid = true;
        if (email === "") {
            setEmailError(true);
            isValid = false;
        }
        if (name === "") {
            setNameError(true);
            isValid = false;
        }
        if (line1 === "") {
            setLine1Error(true);
            isValid = false;
        }
        if (line2 === "") {
            setLine2Error(true);
            isValid = false;
        }
        if (city === "") {
            setCityError(true);
            isValid = false;
        }
        if (state === "") {
            setStateError(true);
            isValid = false;
        }
        if (postalCode === "") {
            setPostalCodeError(true);
            isValid = false;
        }
        if (country === "") {
            setCountryError(true);
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        const billingAddress = {
            email: email,
            name: name,
            address: {
                line1: line1,
                line2: line2,
                city: city,
                state: state,
                postal_code: postalCode,
                country: country,
            },
        };
        onFinish(billingAddress);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-payment-plans-title"
            aria-describedby="modal-payment-plans-description"
        >
            <Box sx={style}>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.semiBold,
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                    }}
                >
                    Billing Info
                </Typography>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                        mt: "1.5rem",
                        mb: "1.125rem",
                    }}
                >
                    Enter your billing address
                </Typography>
                <Box
                    component={"form"}
                    noValidate
                    onSubmit={onSubmit}
                >
                    <Stack
                        spacing={"1.125rem"}
                    >
                        <MainInput
                            name="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setEmailError(e.target.value === "");
                            }}
                            error={emailError}
                            helperText={emailError ? "Email is required" : ""}
                            label="Email"
                        />
                        <MainInput
                            name="name"
                            placeholder="Name"
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                setNameError(e.target.value === "");
                            }}
                            error={nameError}
                            helperText={nameError ? "Name is required" : ""}
                            label="Name"
                        />
                        <MainInput
                            name="line1"
                            placeholder="Address Line 1"
                            value={line1}
                            onChange={(e) => {
                                setLine1(e.target.value);
                                setLine1Error(e.target.value === "");
                            }}
                            error={line1Error}
                            helperText={line1Error ? "Address Line 1 is required" : ""}
                            label="Address Line 1"
                        />
                        <MainInput
                            name="line2"
                            placeholder="Address Line 2"
                            value={line2}
                            onChange={(e) => {
                                setLine2(e.target.value);
                                setLine2Error(e.target.value === "");
                            }}
                            error={line2Error}
                            helperText={line2Error ? "Address Line 2 is required" : ""}
                            label="Address Line 2"
                        />
                        <Grid
                            container
                            spacing={"1rem"}
                            rowSpacing={"0.5rem"}
                        >
                            <Grid item size={{ xs: 12, sm: 6 }}>
                                <MainInput
                                    name="city"
                                    placeholder="City"
                                    value={city}
                                    onChange={(e) => {
                                        setCity(e.target.value);
                                        setCityError(e.target.value === "");
                                    }}
                                    error={cityError}
                                    helperText={cityError ? "City is required" : ""}
                                    label="City"
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}>
                                <MainInput
                                    name="state"
                                    placeholder="State"
                                    value={state}
                                    onChange={(e) => {
                                        setState(e.target.value);
                                        setStateError(e.target.value === "");
                                    }}
                                    error={stateError}
                                    helperText={stateError ? "State is required" : ""}
                                    label="State"
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}>
                                <MainInput
                                    name="zip"
                                    placeholder="ZIP Code"
                                    type="number"
                                    value={postalCode}
                                    onChange={(e) => {
                                        setPostalCode(e.target.value);
                                        setPostalCodeError(e.target.value === "");
                                    }}
                                    error={postalCodeError}
                                    helperText={postalCodeError ? "Postal Code is required" : ""}
                                    label="Postal Code"
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6 }}>
                                <MainInput
                                    name="country"
                                    placeholder="Country"
                                    value={country}
                                    onChange={(e) => {
                                        setCountry(e.target.value);
                                        setCountryError(e.target.value === "");
                                    }}
                                    error={countryError}
                                    helperText={countryError ? "Country is required" : ""}
                                    label="Country"
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"end"} spacing={2} sx={{
                        mt: "2rem",
                    }}>
                        <DefaultButton
                            text={"Cancel"}
                            onClick={onClose}
                            size="medium"
                            sx={{
                                width: 60,
                            }}
                        />
                        <SuccessButton
                            text={"Save Billing Info"}
                            size="medium"
                            type="submit"
                            sx={{
                                width: 140,
                            }}
                        />
                    </Stack>
                </Box>
            </Box>

        </Modal>
    );
}